import {
  Button,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

import { CircularProgress } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { SubHeader } from '@components';
import useDeviceBreakpoints from 'hooks/useDeviceBreakpoints';

import type { FinancialIncomeReportSubHeaderProps } from './types';
import { getLastYears } from '../../utils/getLastYears';
import { PrintButton } from './components';

export function FinancialIncomeReportSubHeader({
  selectedYear,
  setSelectedYear,
  isLoading,
  onFetch,
  data,
  lastYearFetched,
}: Readonly<FinancialIncomeReportSubHeaderProps>) {
  const years = getLastYears(4);
  const { isDesktop } = useDeviceBreakpoints();

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedYear(event.target.value);
  };

  const handleFetch = () => {
    onFetch();
  };

  const { extracts } = data ?? {};

  const hasData = Boolean(data) && (extracts?.length ?? 0) > 0;

  const searchButtonText = isDesktop ? 'Buscar demonstrativo' : ' Buscar';

  return (
    <SubHeader>
      <Grid container spacing={isDesktop ? 3 : 2}>
        <Grid flex={1} item>
          <Select
            value={selectedYear}
            fullWidth
            onChange={handleChange}
            sx={{ maxHeight: '50px' }}
          >
            {years.map(year => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item>
          <Button
            onClick={handleFetch}
            disabled={isLoading}
            variant="outlined"
            color="secondary"
            fullWidth
            endIcon={
              isLoading && (
                <CircularProgress
                  progressColor={NEW_COLORS.GRAYSCALE[700]}
                  size={16}
                />
              )
            }
          >
            {searchButtonText}
          </Button>
        </Grid>
        <Grid item>
          <PrintButton
            hasData={hasData}
            isLoading={isLoading}
            selectedYear={lastYearFetched}
          />
        </Grid>
      </Grid>
    </SubHeader>
  );
}
